import React from "react";
import useAPIError from "./index";
import {
  Modal,
  makeStyles,
  Typography,
  Backdrop,
  Fade,
  LinearProgress,
} from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  modalStyle: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
  },
  paper: {
    position: "absolute",
    width: "50%",
    backgroundColor: "#f5d0ce",
    padding: theme.spacing(3),
    "&:focus": {
      outline: "none",
    },
    textAlign: "center",
  },
  paperWhite: {
    position: "absolute",
    width: "50%",
    backgroundColor: "white",
    padding: theme.spacing(3),
    "&:focus": {
      outline: "none",
    },
    textAlign: "center",
  },
  buttonStyle: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
}));
function APIErrorNotification() {
  const classes = useStyles();
  const { error, removeError, showLoader } = useAPIError();
  console.log(showLoader);
  const handleSubmit = () => {
    removeError();
  };
  const handleClose = (event, reason) => {
    console.log("backdropClick",reason);
    if (error && error?.message){
      removeError();
    }else if(reason !== 'backdropClick' && reason !== 'escapeKeyDown' ){
      removeError();
    }
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modalStyle}
      open={showLoader || !!error}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={showLoader || !!error}>
        <div className={classes.paperWhite}>
          {!!error && (
            <>
              {/* <h3>ERROR!!</h3> */}
              {error && error.message && (
                <Typography varitant="body1" style={{color: "red", fontSize: "1rem !important" }}>{error.message}</Typography>
              )}
            </>
          )}
          {showLoader && <LinearProgress />}
        </div>
      </Fade>
    </Modal>
  );
}

export default APIErrorNotification;
